import ResultsTable from './ResultsTable'

export * from './ResultsTable'
export default ResultsTable
